import {AppState} from '../store';

export const getWeb3Provider = (state: AppState) => state.web3.provider;
